<div class="maintenance-container">
    <div class="illustration-container">
        <!-- Make sure to place maintenance.png in your assets folder -->
        <img src="assets/maintenance.png" alt="Scheduled Maintenance" class="img-maintenance" />
    </div>

    <h1 class="main-title">Scheduled Maintenance</h1>

    <p class="description">
        The site is currently undergoing scheduled upgrades to improve<br>your wayfinding experience. We'll be back online shortly.
    </p>

    <div class="action-buttons">
        <button class="btn-dashboard" (click)="goToDashboard()">
            BACK TO DASHBOARD
        </button>
    </div>

    <div class="shortcuts-section">
        <h6 class="section-title">POPULAR SHORTCUTS</h6>
        <div class="shortcuts-grid">
            <button class="btn-shortcut" (click)="goToHelpCenter()">Help Center</button>
            <button class="btn-shortcut" (click)="goToSystemStatus()">System Status</button>
            <button class="btn-shortcut" (click)="goToReleaseNotes()">Release Notes</button>
        </div>
    </div>
</div>
